const ignore = (...args: any[]) => args;

export const studioGlobals = {
  useTransform: (...args: any[]) => {
    ignore(args);
    return {} as any;
  },
  useSize: (...args: any[]) => {
    ignore(args);
    return {} as any;
  },
  useElementSelection: (...args: any[]) => {
    ignore(args);
    return {} as any;
  },
  Element: null as any,
  ElementControlsLayer: null as any,
};

export const setStudioUseTransform = (hook: any) => {
  studioGlobals.useTransform = hook;
};

export const setStudioUseSize = (hook: any) => {
  studioGlobals.useSize = hook;
};

export const setStudioUseElementSelection = (hook: any) => {
  studioGlobals.useElementSelection = hook;
};

export const setStudioElement = (Element: any) => {
  studioGlobals.Element = Element;
};

export const setStudioElementControlsLayer = (ElementControlsLayer: any) => {
  studioGlobals.ElementControlsLayer = ElementControlsLayer;
};
